import { render, staticRenderFns } from "./list.vue?vue&type=template&id=bd5fe67a&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=bd5fe67a&prod&lang=scss&scoped=true"
import style1 from "./list.vue?vue&type=style&index=1&id=bd5fe67a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5fe67a",
  null
  
)

export default component.exports